import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t">
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Address Section - Adjacent in Desktop */}
        <div className="flex flex-col md:flex-row justify-center md:space-x-12 space-y-8 md:space-y-0 mb-8">
          {/* Location 1 */}
          <div className="md:border-r md:pr-12">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">MUMBAI OFFICE ADDRESS</h3>
            <div className="flex items-start space-x-3 mb-3">
              <MapPin className="w-5 h-5 mt-1 flex-shrink-0 text-gray-600" />
              <p className="text-gray-600">
                C-503, DEVASHREE GARDEN,<br />
                NEAR RUTU PARK,<br />
                MAJIWADA, THANE (W)<br/>
                PIN-CODE-400601<br/>
                MAHARASHTRA - INDIA.
              </p>
            </div>
            <div className="flex items-center space-x-3 mb-3">
              <Phone className="w-5 h-5 flex-shrink-0 text-gray-600" />
              <p className="text-gray-600"><a href="tel:+919967289909">+91-9967289909</a></p>
              <p className="text-gray-600"><a href="tel:+919833081622">+91-9833081622</a></p>
            </div>
            <div className="flex items-center space-x-3">
              <Mail className="w-5 h-5 flex-shrink-0 text-gray-600" />
              <a href="mailto:sales@ultronics.in" className="text-gray-600 hover:text-gray-900 transition-colors">
              sales@ultronics.in
              </a>
            </div>
            <div className="flex items-center space-x-3">
              <Mail className="w-5 h-5 flex-shrink-0 text-gray-600" />
              <a href="mailto:info@ultronics.in" className="text-gray-600 hover:text-gray-900 transition-colors">
              info@ultronics.in
              </a>
            </div>
          </div>

          {/* Location 2 */}
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">FACTORY ADDRESS</h3>
            <div className="flex items-start space-x-3 mb-3">
              <MapPin className="w-5 h-5 mt-1 flex-shrink-0 text-gray-600" />
              <p className="text-gray-600">
              B-31 & 32, ARIHANT INDUSTRIAL ESTATE,<br/>
              VASAI PHATA,<br/>
              VASAI EAST, DISTRICT PALGHAR<br/>
              PIN CODE - 401208
              </p>
            </div>
            {/* <div className="flex items-center space-x-3 mb-3">
              <Phone className="w-5 h-5 flex-shrink-0 text-gray-600" />
              <p className="text-gray-600">+44 20 7123 4567</p>
            </div>
            <div className="flex items-center space-x-3">
              <Mail className="w-5 h-5 flex-shrink-0 text-gray-600" />
              <a href="mailto:london@example.com" className="text-gray-600 hover:text-gray-900 transition-colors">
                london@example.com
              </a>
            </div> */}
          </div>
        </div>

        {/* Quick Links Section - Horizontal */}
        <div className="border-t border-b py-6">
          <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3">
            <a href="/" className="text-gray-600 hover:text-gray-900 transition-colors font-medium">
              Home
            </a>
            <a href="/products" className="text-gray-600 hover:text-gray-900 transition-colors font-medium">
              Products
            </a>
            <a href="/about" className="text-gray-600 hover:text-gray-900 transition-colors font-medium">
              About Us
            </a>
            <a href="/contact" className="text-gray-600 hover:text-gray-900 transition-colors font-medium">
              Contact Us
            </a>
            <a href="/e-catalogue" className="text-gray-600 hover:text-gray-900 transition-colors font-medium">
              E-Catalogue
            </a>
          </nav>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Ultronics. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;